import { render } from "./InitialForm.vue?vue&type=template&id=344421d4"
import script from "./InitialForm.vue?vue&type=script&lang=js"
export * from "./InitialForm.vue?vue&type=script&lang=js"

import "./InitialForm.vue?vue&type=style&index=0&id=344421d4&lang=css"

import exportComponent from "C:\\Users\\LENOVO\\Desktop\\Septem\\mobins.frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__